import { useEffect, useState } from "react";
import { CounterInputV2, InputV2 } from "../../../FormControlsV2";
import { MessageBalloon } from "../../../MessageBalloon/Index";
import { ReactComponent as PointIcon } from "../../../../assets/svg/icons/point.svg";
import { ReactComponent as AreaIcon } from "../../../../assets/svg/icons/areaIcon.svg";
import { ReactComponent as AnimalsIcon } from "../../../../assets/svg/icons/animais.svg";
import { ReactComponent as GrassIcon } from "../../../../assets/svg/icons/grass.svg";
import { ButtonPressed } from "../../../Buttons/ButtonPressed";
import { ButtonYesOrNo } from "../../../Buttons/ButtonYesOrNo";
import { format } from "date-fns";
import { parseUtcDate } from "../../../../utils/date/formatedDate";

interface InfoSprayingProps {
  task: ITaskSpraying | undefined;
}

export default function InfoSpraying(task: InfoSprayingProps) {
  const [taskSpraying, setTaskSpraying] = useState<ITaskSpraying>();
  const hasSkipReason = taskSpraying?.skip_reason != null;
  const mapOperationType = new Map<string, string>([
    ["MECANIZADA", "Mecanizada"],
    ["MANUAL", "Manual"],
    ["AVIÃO_OU_DRONE", "Avião ou Drone"],
  ]);

  useEffect(() => {
    setTaskSpraying(task.task);
  }, []);

  return (
    <>
      <div>
        <span>No pasto</span>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <GrassIcon width={30} className="iconInitialTaskInfo" />
          <div className="labelInitialTaskInfo">
            <span>{taskSpraying?.initials}</span>
            <PointIcon width={15} />
          </div>
        </div>
      </div>

      <div className="containerQuestion">
        <MessageBalloon text={`A tarefa foi iniciada?`} pointed />
        <ButtonYesOrNo
          onlyResult
          optionSelected={hasSkipReason ? "no" : "yes"}
        />
      </div>

      {hasSkipReason ? (
        <MessageBalloon text={`${taskSpraying?.skip_reason}`} answer />
      ) : (
        <>
          {taskSpraying?.product_name && (
            <MessageBalloon text={taskSpraying.product_name} pointed />
          )}
          {taskSpraying?.liter_per_ha != null && (
            <CounterInputV2
              name="info-spraying-ml-ha"
              suffix="ml/ha"
              value={String(taskSpraying.liter_per_ha)}
              disabled
            />
          )}

          <div className="containerQuestion">
            <MessageBalloon text={`Qual o tipo de operação?`} pointed />
            <ButtonPressed
              onlyResult
              optionSelected={1}
              value={1}
              text={`${mapOperationType.get(taskSpraying?.operation_type || "")}`}
            />
          </div>

          {taskSpraying?.operation_type == "MECANIZADA" && (
            <>
              <MessageBalloon
                text={`${format(parseUtcDate(taskSpraying?.start_time) || 0, "dd/MM/yyyy - HH:mm")}`}
              />

              <MessageBalloon text={`Informar horímetro inicial`} />
              <CounterInputV2
                name="info-spraying-initial-h"
                suffix="h"
                value={Number(taskSpraying?.initial_hour_meter ?? 0)}
                disabled
              />

              <ButtonPressed
                onlyResult
                optionSelected={1}
                value={1}
                text={`Horímetro final`}
              />

              <MessageBalloon
                text={`${format(parseUtcDate(taskSpraying?.end_time) || 0, "dd/MM/yyyy - HH:mm")}`}
              />

              <MessageBalloon text={`Informar horímetro final`} />
              <CounterInputV2
                name="info-spraying-final-h"
                suffix="h"
                value={Number(taskSpraying?.final_hour_meter ?? 0)}
                disabled
              />
            </>
          )}
        </>
      )}
    </>
  );
}
